import { ElementType, HTMLAttributes, LabelHTMLAttributes, createElement } from "react";

import { SkeletonWrapper } from "../SkeletonWrapper";

type Props = HTMLAttributes<HTMLElement> &
	LabelHTMLAttributes<HTMLLabelElement> & {
		skeleton?: boolean;
		text: string;
		skeletonWidth?: string;
		skeletonHeight?: string | number;
		containerClassName?: string;
		skeletonClassName?: string;
		tag: ElementType;
	};

export function TagHTMLOrSkeleton({
	skeleton,
	text,
	skeletonWidth,
	skeletonHeight,
	containerClassName,
	skeletonClassName,

	tag,
	...rest
}: Props) {
	return skeleton ? (
		<SkeletonWrapper
			width={skeletonWidth}
			height={skeletonHeight}
			containerClassName={containerClassName}
			className={skeletonClassName}
		/>
	) : (
		createElement(tag, rest, text)
	);
}
